import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function ProgramsEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [programName, setProgramName] = useState('');
  const [programCode, setProgramCode] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [tooltip, setTooltip] = useState('');

  useEffect(() => {
    axios.get('/api/program-categories')
      .then(response => {
        setCategories(response.data);
      })
      .catch(err => {
        console.error('Error fetching program categories', err);
      });

    axios.get(`/api/programs/${id}`)
      .then(response => {
         const data = response.data;
         setProgramName(data.name);
         setProgramCode(data.code);
         setSelectedCategory(data.programCategory?.id || '');
      })
      .catch(() => {
         setTooltip('Error fetching program details.');
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: programName,
      code: programCode,
      programCategory: { id: parseInt(selectedCategory, 10) }
    };
    axios.put(`/api/programs/${id}`, payload)
      .then(() => {
         setTooltip('Program updated successfully!');
         setTimeout(() => navigate('/admin/programs/view'), 2000);
      })
      .catch(() => {
         setTooltip('Error updating program.');
      });
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Program" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Program Name</label>
              <input 
                type="text" 
                className="form-control"
                value={programName}
                onChange={(e) => setProgramName(e.target.value)}
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Program Code</label>
              <input 
                type="text" 
                className="form-control"
                value={programCode}
                onChange={(e) => setProgramCode(e.target.value)}
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Program Category</label>
              <select 
                className="form-select"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                required
              >
                <option value="">Select Category</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
            <button type="submit" className="btn btn-primary">Update Program</button>
          </form>
        </div>
      </div>
      {tooltip && (
        <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default ProgramsEdit;
